module.exports = __webpack_public_path__ + "img/icon_cardnumber.3132458.svg";